export default __webpack_public_path__ + "static/media/sam-and-karen-bridge.0cf92295.jpeg";